import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Data untuk Slideshow
  const slides = [
    { image: "https://images.unsplash.com/photo-1549931319-a545dcf3bc73?w=800&q=80", text: "Fresh from the oven every morning" },
    { image: "https://images.unsplash.com/photo-1481391243133-f96216dcb5d2?w=800&q=80", text: "Handmade Pâtisserie for your sweet tooth" },
    { image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&q=80", text: "Authentic French Baguettes" }
  ];

  // Logic Slideshow gerak sendiri tiap 3 detik
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div>
      {/* Hero Section */}
      <header className="hero">
        <div>
          <h1>Real French Bread, Local Vibe</h1>
          <p style={{ fontSize: '1.2rem', marginTop: '1rem', marginBottom: '2rem' }}>
            We wake up early so you can enjoy fresh croissants.
          </p>
          <Link to="/menu">
            <button className="btn">Check Our Menu</button>
          </Link>
        </div>
      </header>

      {/* About Us Section - Bahasa lebih natural */}
      <section className="about-section">
        <img 
          src="https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=800&q=80" 
          alt="Baking Process" 
          className="about-img"
        />
            <div className="about-content">
        <h4 style={{ color: '#d84315', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '1rem' }}>Our Story</h4>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1.5rem' }}>There Are Things You Cannot Rush.</h2>
        <p style={{ lineHeight: '1.8', marginBottom: '1.5rem', color: '#5d4037' }}>
          La Provence was founded on a simple belief a proper crust, a slow ferment, the smell of bread pulled fresh from the oven at dawn. We saw a city without a real French baguette and decided to change that, quietly, one loaf at a time.
        </p>
        <p style={{ lineHeight: '1.8', color: '#5d4037' }}>
          Nothing but quality flour, pure water, and European butter. No preservatives. No compromise. Every piece that leaves our kitchen is baked the same morning you taste it. That is the only standard we know.
        </p>
      </div>
      </section>

      {/* Slideshow Section */}
      <section className="container" style={{ backgroundColor: '#faf8f5', paddingBottom: '6rem' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '2rem', fontSize: '2.5rem' }}>What's Fresh Today</h2>
        
        <div className="slideshow-container">
          {slides.map((slide, index) => (
            <div key={index} style={{ position: 'relative' }}>
              <img 
                src={slide.image} 
                alt={slide.text} 
                className={`slide-img ${index === currentSlide ? 'active' : ''}`} 
              />
              {index === currentSlide && (
                <div className="slide-text">{slide.text}</div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;